/*
================================================
Une mixin pour la gestion des timezone
https://fr.vuejs.org/v2/guide/mixins.html
================================================
*/
var TimezoneMixin = {
    created(){
        // this.hello()
    },

    data: function () {
        return {
            // message: 'bonjour',
            // foo: 'abc'
        }
    },
    methods: {
        /**
         * Detect the timezone
         */
        detectTimezone: function (){
            var jstz = require('jstz');
            var timezone = jstz.determine();
            return  timezone.name()
        }
    },

}

export default TimezoneMixin;
